import { requestNavClose } from "../helpers/nav_helpers";

export default function mapOverlaySelected(sm) {
    requestNavClose(); // Request the Nav to close (it owns navOpen); reflected back as navOpenReflected.
}
